import React, { useContext } from 'react'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import { SignUpSignInModal } from 'components/SignUpSignInModal/SignUpSignInModal'

const SignInUpModal = () => {
  const modal_context = useContext(modalContext)
  const { signInUpModal, setSignInUpModal } = modal_context || {}

  return (
    <SignUpSignInModal
      open={signInUpModal}
      handleClose={() => {
        setSignInUpModal(false)
      }}
    />
  )
}

export default SignInUpModal
